import styled from 'styled-components'

export const LabelWrapper = styled.div`

`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
`

export const Footer = styled.div`
  background: rgba(32, 32, 32, 0.03);
  padding: 32px 16px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
`

export const TwoStepMultiSelectContainer = styled.div`
  border: 1px solid rgba(32, 32, 32, 0.1);
  box-sizing: border-box;
  box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05);
  border-radius: 4px;  
  background: rgba(32, 32, 32, 0.02);
  margin-bottom: ${(props) => {
    return props.marginBottom
  }};
  margin-top: ${(props) => {
    return props.marginTop
  }};
`

export const FirstStepSelectWrapper = styled.div`
  width: 88px;
  margin-right: 16px;
`
export const SecondStepSelectWrapper = styled.div`
  width: 400px;
  padding-left: 8px;
`
